const truncateText = (text?: string, limit?: number) => {
  if (typeof text !== 'string' || typeof limit !== 'number') return '';
  if (text.length > limit) {
    return `${text.slice(0, limit - 2)}...`;
  } else return text;
};

const isTruncated = (text?: string, limit?: number) => {
  if (typeof text !== 'string' || typeof limit !== 'number') return false;
  if (text.length >= limit) return true;
  return false;
};

const capitalize = (word: string) => {
  if (word !== null && word !== undefined) {
    const value = word.toLowerCase().replace(/_/g, ' ');
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
};

export { truncateText, isTruncated, capitalize };
